import { useEffect, useState } from "react";
import type { MenuGroup, RenderLink } from "./menu";

type Props = {
  menu: MenuGroup[];
  currentPath: string;
  renderLink: RenderLink;
  /** Desktop recolhido: só ícones, com o nome no aria-label e o submenu como flyout. */
  collapsed?: boolean;
  /** Celular: o menu fica fora da tela e inerte até ser aberto. */
  mobile?: boolean;
  mobileOpen?: boolean;
  id?: string;
};

export function Sidebar({
  menu,
  currentPath,
  renderLink,
  collapsed = false,
  mobile = false,
  mobileOpen = false,
  id = "cx-sidebar",
}: Props) {
  const initial = menu.find((g) => g.items.some((i) => currentPath.startsWith(i.to)))?.key;
  const [open, setOpen] = useState<string | undefined>(collapsed ? undefined : initial);
  // No modo recolhido o flyout fecha ao navegar.
  useEffect(() => {
    if (collapsed) setOpen(undefined);
  }, [currentPath, collapsed]);
  return (
    <aside
      id={id}
      className={`main-sidebar${mobileOpen ? " mobile-open" : ""}`}
      aria-label="Menu principal"
      inert={mobile && !mobileOpen}
    >
      <nav className="sidebar">
        <ul className="sidebar-menu list-unstyled" role="list">
          {menu.map((g) => {
            const Icon = g.icon;
            const isOpen = open === g.key;
            return (
              <li key={g.key} className={`treeview${isOpen ? " menu-open" : ""}`}>
                <button
                  type="button"
                  className="btn btn-link text-reset text-decoration-none w-100 text-start d-flex align-items-center gap-2"
                  aria-expanded={isOpen}
                  aria-controls={`menu-${g.key}`}
                  aria-label={collapsed ? g.label : undefined}
                  title={collapsed ? g.label : undefined}
                  onClick={() => setOpen(isOpen ? undefined : g.key)}
                >
                  <Icon size={18} aria-hidden="true" />
                  <span className="menu-label">{g.label}</span>
                </button>
                <ul id={`menu-${g.key}`} className="treeview-menu list-unstyled ps-4" hidden={!isOpen}>
                  {g.items.map((i) => {
                    const active = currentPath.startsWith(i.to);
                    return (
                      <li key={i.to} className={active ? "active" : undefined}>
                        {renderLink(i.to, i.label, active)}
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
